import { createAsyncThunk } from "@reduxjs/toolkit";
import { useCustomAxios } from "../../shared/lib/customAxios";
import { ISignin } from "../../shared/models/signin";
import { API_ENDPOINTS, SOURCE } from "../../shared/constants/constants";

export const signInApi = createAsyncThunk(
  "user/signin",
  async (reqBody: ISignin, { rejectWithValue }) => {
    const { axiosPost, axiosGet } = useCustomAxios();

    try {
      const response = await axiosPost(API_ENDPOINTS.login, reqBody);

      const defaultConfig = {
        headers: {
          Authorization: `Bearer ${response?.data?.authorizationToken}`,
          "x-source": SOURCE.RECEIVEAPP,
        },
      };

      const partyURL = API_ENDPOINTS.getPartyByPartyId.replace(
        ":id",
        response.data.party._id,
      );
      const userDetails = await axiosGet(partyURL, defaultConfig);

      return {
        data: {
          ...response.data,
          location: [],
          userName:
            userDetails?.data?.details?.name ||
            userDetails?.data?.details?.groupName,
        },
        statusCode: response.status,
      };
    } catch (error: any) {
      return rejectWithValue(error.response.data.message);
    }
  },
);

export const verifyToken = createAsyncThunk(
  "verifyToken",
  async (_, { rejectWithValue }) => {
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(API_ENDPOINTS.verifyToken, {});
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const forgotPasswordSendOtp = createAsyncThunk(
    "user/forgotPassword/sendOtp",
    async (reqBody: any, { rejectWithValue }) => {
        try {
            const url = API_ENDPOINTS.forgotPasswordSendOtp;
            const { axiosPost } = useCustomAxios();
            const response = await axiosPost(url, reqBody);
            return {
                data: response.data,
                status: response.status,
            }
        }
        catch (error: any) {
            return rejectWithValue(error.response.data.message)
        }
    }
)

export const forgotPasswordVerifyOtp = createAsyncThunk(
    "user/forgotPassword/verifyOtp",
    async (reqBody: any, { rejectWithValue }) => {
        try {
            const url = API_ENDPOINTS.forgotPasswordVerifyOtp;
            const { axiosPost } = useCustomAxios();
            const response = await axiosPost(url, reqBody);
            return {
                data: response.data,
                status: response.status,
            }
        }
        catch (error: any) {
            return rejectWithValue(error.response.data.message)
        }
    }
)

export const resetAccountPassword = createAsyncThunk(
    "user/resetAccountPassword",
    async (reqBody: any, { rejectWithValue }) => {
        try {
            const { data, authToken } = reqBody;
            const url = API_ENDPOINTS.partyResetAccountPassword;
            const { axiosPost } = useCustomAxios();

            const config = { headers: { Authorization: `Bearer ${authToken}`, "x-source": SOURCE.RECEIVEAPP } }

            const response = await axiosPost(url, data, config);
            return {
                data: response.data,
                status: response.status,
            }
        }
        catch (error: any) {
            return rejectWithValue(error.response.data.message)
        }
    }
)
